/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardThreatsAccountDetails {
    getFixupPrototypeFunction() { return SecurityDashboardThreatsAccountDetails.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardThreatsAccountDetails>): SecurityDashboardThreatsAccountDetails {
        let obj = Object.assign(new SecurityDashboardThreatsAccountDetails(), model);
        SecurityDashboardThreatsAccountDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardThreatsAccountDetails>): SecurityDashboardThreatsAccountDetails {
        if (!model) return null;
        return SecurityDashboardThreatsAccountDetails.newInstance(<SecurityDashboardThreatsAccountDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardThreatsAccountDetails) {
        if (!obj) return;

        models.SecurityDashboardThreatsAccountDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardThreatsAccountDetails): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardThreatsAccountDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count_by_severity) {
            models.SecurityDashboardSeverity.fixupPrototype(this.count_by_severity);
        }
    }

    /**
     * Tenant value
     */
    tenant_id: string;

    /**
     * Cloud Account value
     */
    cloud_account_id: string;

    /**
     * Service Account Name
     */
    service_account_name: string;

    /**
     * Visibility for the Cloud Provider
     */
    cloud_provider: models.CloudServiceName;

    /**
     * Threats Severity Values
     */
    count_by_severity: models.SecurityDashboardSeverity;

}
